<template>
	<section v-if="items.length > 0" class="expired-jobs">
		<header>
			<h2>Open roles like this one</h2>
		</header>

		<div class="inner">
			<template v-for="item of items" :key="item.uuid">
				<job-deck
					v-if="item.variant_preview && item.variant_preview.length > 1"
					:item="item"
					:hide_summary="true"
					:hide_apply_button="true"
					:logo_url_template="logo_url_template"
				/>

				<job
					v-else
					:item="item"
					:hide_summary="true"
					:hide_apply_button="true"
					:logo_url_template="logo_url_template"
				/>
			</template>
		</div>

		<footer v-if="hub_url">
			<a :href="hub_url" class="btn btn-solid"> Browse All Jobs </a>
		</footer>
	</section>
</template>

<style lang="scss" scoped>
@use 'sass:math';

@use '/sass/variables' as *;
@use '/sass/toolkit' as *;

header {
	margin-bottom: 1rem;

	h2 {
		@include h4;
	}
}

.inner {
	margin-bottom: 1rem;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: $spacer;

	.job-deck {
		margin-bottom: 1em;
	}
}

@include media('<=landscape') {
	.inner {
		grid-template-columns: repeat(2, 1fr);
	}
}

@include media('<=phone') {
	.inner {
		grid-template-columns: 1fr;
	}
}

footer {
	display: flex;
	justify-content: center;

	.btn-bordered {
		font-size: 1rem;
	}
}
</style>

<script setup>
import { useFetch } from '@vueuse/core';
import { computed } from 'vue';

import Job from '../jobs-app/_job.vue';
import JobDeck from '../jobs-app/_job-deck.vue';

const props = defineProps({
	api_url: {
		type: String,
		required: true,
	},
	uuid: {
		type: String,
		required: true,
	},
	hub_url: {
		type: String,
		required: true,
	},
	logo_url_template: {
		type: String,
		required: true,
	},
});

const { data } = useFetch(`${props.api_url}/api/listings/${props.uuid}/related?grouped=true&limit=5`, {
	credentials: `same-origin`,
})
	.get()
	.json();

const items = computed(() => (data.value || []).slice(0, 5));
</script>
